import {useEffect, useState} from 'react';
import {Link} from 'react-router';
import {getUsers, setNewUser, setUserActive} from "../../api/Api";
import {Button, Divider, Input, Select, Table, Row, Col, message, Card} from 'antd';
import {UserActiveWidget} from "./UserActiveWidget";
import {DepartmentChangeWidget} from "./DepartmentChangeWidget";
import {departmentOptions} from "./DepartmentOptions";

export const UserTab = ({onApiFail, refresh, onRefresh}) => {
    const [users, setUsers] = useState([]);
    const [messageApi, contextHolder] = message.useMessage();

    const onFail = (e) => {
        if (e.status === 401) {
            if (onApiFail) {
                onApiFail();
            }
        }
    }

    useEffect(() => {
        getUsers().then(us => {
            if (us !== undefined) {
                us.forEach(u => {
                    u.key = u.id;
                });
                setUsers(us);
            } else {
                setUsers([]);
            }
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        });
    }, [refresh, onApiFail]);

    const setActive = (record) => (val) => {
        console.log(`setUserActive ${record.id} ${val}`)
        setUserActive(record.id, val).then(r => {
            if (onRefresh) { onRefresh() }
            messageApi.open({
                type: 'success',
                content: val ? `User is Active` : `User is Disabled`
            })
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        });
    }

    const columns = [
        {
            title: 'Username',
            dataIndex: 'username',
            key: 'username',
            render: (val, user, index) => {
                // return <Collapse ghost items={[{key: 1, label: val, children: <PasswordInput user={user} onApiFail={onApiFail}/>}]} />
                return <Link to={`/user/${user.id}`}>{val}</Link>
            }
        },
        {
            title: 'First Name',
            dataIndex: 'firstname',
            key: 'firstname',
        },
        {
            title: 'Last Name',
            dataIndex: 'lastname',
            key: 'lastname',
        },
        {
            title: 'Department',
            dataIndex: 'department',
            key: 'department',
            render: (val, user, index) => {
                return <div style={{ width: 120 }}><DepartmentChangeWidget user={user} onApiFail={onApiFail} onRefresh={onRefresh} refresh={refresh} /></div>
            }
        },
        {
            title: 'Access',
            dataIndex: 'active',
            key: 'active',
            render: (val, record) => {
                return <UserActiveWidget active={val} setActive={setActive(record)} />
            }
        }
    ];

    const [newUserName, setNewUserName] = useState("");
    const [newUserLastName, setNewUserLastName] = useState("");
    const [newUserDepartment, setNewUserDepartment] = useState(undefined);
    const [newUserPassword, setNewUserPassword] = useState("");
    const [newUsername, setNewUsername] = useState("");
    const onNameChange = (e) => {
        setNewUserName(e.target.value);
    }
    const onLastNameChange = (e) => {
        setNewUserLastName(e.target.value);
    }
    const onUsernameChange = (e) => {
        setNewUsername(e.target.value);
    }
    const onNewUserDepartmentChange = (val) => {
        setNewUserDepartment(val);
    }
    const onNewUserPasswordChange = (e) => {
        console.log(`new user pw ${e.target.value}`);
        setNewUserPassword(e.target.value);
    }
    const clearForm = () => {
        setNewUserName("");
        setNewUserLastName("");
        setNewUsername("");
        setNewUserPassword("");
        setNewUserDepartment(undefined);
    }
    const onSubmit = () => {
        setNewUser(newUsername, newUserName, newUserLastName, newUserDepartment, newUserPassword).then(x => {
            if (onRefresh) onRefresh();
            messageApi.open({
                type: 'success',
                content: 'User Created'
            })
        }).catch(e => {
            console.log(`set new user failed ${e}`);
            onFail(e);
            messageApi.open({
                type: 'error',
                content: 'Failed to Create User'
            })
        }).finally(() => {
            clearForm();
        });
    }

    const submitDisabled = (newUserName.length === 0) || (newUsername.length === 0) || (newUserPassword.length === 0)
        || (newUserDepartment === undefined);

    const rowStyle = {
        marginTop: '5px',
        marginBottom: '5px'
    }

    const labelStyle = {
        marginTop: '5px'
    }

    return <div>
        {contextHolder}
        <Table columns={columns} dataSource={users} />
        <Divider />
        <Card style={{textAlign: 'left'}} title={<b>Create User</b>}>
        <Row style={rowStyle}>
            <Col span={2} style={labelStyle}>First Name: </Col>
            <Col span={6}><Input onChange={onNameChange} value={newUserName} placeholder={`First Name`}/></Col>
        </Row>
        <Row style={rowStyle}>
            <Col span={2} style={labelStyle}>Last Name: </Col>
            <Col span={6}><Input onChange={onLastNameChange} value={newUserLastName} placeholder={`Last Name`}/></Col>
        </Row>
        <Row style={rowStyle}>
            <Col span={2} style={labelStyle}>Username: </Col>
            <Col span={6}><Input onChange={onUsernameChange} value={newUsername} placeholder={`Username`}/></Col>
        </Row>
        <Row style={rowStyle}>
            <Col span={2} style={labelStyle}>Password: </Col>
            <Col span={6}><Input.Password onChange={onNewUserPasswordChange}value={newUserPassword} placeholder={`Password`} /></Col>
        </Row>
        <Row style={rowStyle}>
            <Col span={2} style={labelStyle}>Department: </Col>
            <Col span={6}><Select placeholder={'Department'} style={{width: 240}} options={departmentOptions} onChange={onNewUserDepartmentChange} value={newUserDepartment}/></Col>
        </Row>
        <Row style={rowStyle}>
            <Col style={labelStyle}>
                <div style={{textAlign: 'left'}}><Button onClick={onSubmit} disabled={submitDisabled}>Submit</Button></div>
            </Col>
        </Row>
        <Divider />
        </Card>
    </div>
}